import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Icon } from "@common/Icon/Icon";
import { HOME_PAGE_URL } from "@constants";

interface IParams {
    email: string;
    isVerified: boolean;
}
export const ForgotEmailSuccess = (props: IParams) => {
    const { email, isVerified } = props;
    const { t } = useTranslation(["glossary", "forgotEmail"]);

    return (
        <Grid alignItems="center" container direction="column" spacing={2}>
            <Grid item>
                <Typography>
                    <Icon className="icon-light-grey" name="paper-plane" size="large" />
                </Typography>
            </Grid>
            <Grid item>
                <Typography align="center" color="secondary">
                    {t("glossary:thankYou")} ! <br />
                    {t("forgotEmail:emailAddressIs")}:
                </Typography>
            </Grid>
            <Grid item>
                <Typography color="primary" variant="overline">
                    {email}
                </Typography>
            </Grid>
            <Grid item>
                {isVerified && (
                    <Typography align="center" color="secondary">
                        {t("forgotEmail:toLogin")}: <br />
                        <Link color="inherit" to={HOME_PAGE_URL}>
                            {t("forgotEmail:clickHere")}
                        </Link>
                    </Typography>
                )}
                {!isVerified && (
                    <Typography align="center" color="secondary" data-testid="verified-email-test">
                        {t("forgotEmail:notVerifiedHelper")}
                    </Typography>
                )}
            </Grid>
        </Grid>
    );
};
